import {useLocation} from 'react-router-dom';

export default function useCustomLocation() {
    const location = useLocation()
    return {pathName: '#' + location.pathname}
}